module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/130.cb8a7378.svg";